/* eslint-disable react/jsx-props-no-spreading */
// React
import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

// Components
import Header from '@/components/organisms/Header/Header';
import Footer from '@/components/organisms/Footer/Footer';
import BackgroundBubble from '@/components/atoms/BackgroundBubble/BackgroundBubble';

// Types
import { HeaderType } from '@/components/organisms/Header/HeaderType';
import { FooterType } from '@/components/organisms/Footer/FooterType';

interface LayoutHeaderFooterProps {
  children: React.ReactNode;
  header: HeaderType;
  footer: FooterType;
  breadcrumb?: boolean;
}

function LayoutHeaderFooter({ header, footer, children, breadcrumb = false }: LayoutHeaderFooterProps) {
  const [fixedLayer, setFixedLayer] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setFixedLayer(document.getElementById('fixed-layer'));
  }, []);

  return (
    <>
      {fixedLayer && createPortal(
        <>
          <BackgroundBubble />
          <Header {...header} />
        </>,
        fixedLayer,
      )}
      {children}
      <Footer {...footer} breadcrumb={breadcrumb} />
    </>
  );
}

export default LayoutHeaderFooter;
